import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <g opacity="0.4">
      <path
        clipRule="evenodd"
        d="M1.40723 2.37225C0.477796 2.37225 -0.196049 3.25774 0.0516989 4.15355L4.34058 19.6613H12.6983L8.35055 3.41508C8.18595 2.80001 7.62866 2.37225 6.99195 2.37225H1.40723ZM5.76758 17.7861L2.02328 4.24747L6.6321 4.24747L10.2553 17.7861H5.76758Z"
        fill="#21201F"
        fillRule="evenodd"
      />
      <path
        d="M10.081 7.99703H13.4828C14.123 8.00828 14.6894 8.41896 14.8981 9.02643L15.6424 11.7472H15.9041C16.7831 11.7472 17.4193 10.9082 17.182 10.0618L16.9453 9.21709C16.7456 8.50464 16.1017 8.0094 15.3642 7.99703H17.879C18.6341 7.99703 19.2953 8.50321 19.4925 9.23205L21.073 15.0758L21.1323 15.3083C21.3925 16.3284 20.6561 17.3322 19.6049 17.3902L14.0714 17.6958C13.2828 17.7393 12.5713 17.2249 12.3655 16.4624L10.081 7.99703Z"
        fill="#21201F"
      />
    </g>
    <path
      d="M3.36124 10.2496C2.5332 10.5365 2.06741 11.4143 2.29395 12.2609L3.96393 18.5015C4.0043 18.6523 4.06408 18.7929 4.13985 18.921C3.66797 19.3498 3.37171 19.9684 3.37171 20.6563C3.37171 21.9508 4.42117 23.0003 5.71573 23.0003C6.84975 23.0003 7.79568 22.195 8.01286 21.1251H10.9194C11.1366 22.195 12.0825 23.0003 13.2165 23.0003C14.5111 23.0003 15.5606 21.9508 15.5606 20.6563C15.5606 20.5959 15.5583 20.5361 15.5538 20.4769L22.7754 18.4796C23.5167 18.2746 24.0025 17.5998 23.999 16.8652C23.9983 16.7237 23.9795 16.58 23.9408 16.437L17.8096 16.437L17.8018 16.4417L13.9801 17.4595L11.7506 9.23297C11.5478 8.48455 10.8713 7.99915 10.14 7.99817C9.95794 7.99793 9.77251 8.0277 9.59013 8.0909L3.36124 10.2496Z"
      fill="#21201F"
    />
  </>,
  'SortCenterIcon',
)
